import { render, staticRenderFns } from "./returnRecordList.vue?vue&type=template&id=106469e4"
import script from "./returnRecordList.vue?vue&type=script&lang=js"
export * from "./returnRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports